import type { Theme } from '@mui/material/styles';
import type { Components } from '@mui/material/styles/components';

export const MuiInputLabel: Components<Theme>['MuiInputLabel'] = {
  styleOverrides: {
    shrink: ({ theme }: { theme: Theme }) => ({
      color: theme.palette.text.secondary,
    }),
  },
};
